import React, { Component } from 'react';
import { Alert } from "react-bootstrap";

export default class BetterAlerts extends Component {

    render() {
        return (
            <div style={{ marginLeft: '20px', marginRight: '20px' }}>
                {this.props.errors ?
                    this.props.errors.map((obj, i) => {
                        return <Alert key={i} variant="danger">{obj}</Alert>
                    })
                    : null
                }

                {this.props.success ?
                    this.props.success.map((obj, i) => {
                        return <Alert key={i} variant="success">{obj}</Alert>
                    })
                    : null
                }

				{this.props.info ?
                    this.props.info.map((obj, i) => {
                        return <Alert key={i} variant="info">{obj}</Alert>
                    })
                    : null
                }

				{this.props.warning ?
                    this.props.warning.map((obj, i) => {
                        return <Alert key={i} variant="warning">{obj}</Alert>
                    })
                    : null
                }
            </div>
        );
    }
}